import { useSelector } from 'react-redux';
import { BuilderReviews } from '../../components/BuilderReviews';
import * as React from 'react';
import { useApplicationContext } from '../../utils/applicationContext';
import { selectBuilderInfo } from '../../selectors/builder';

const REVIEWS_BASE_URL = 'https://cian.site/country-builder-reviews/';

export const BuilderReviewsContainer = () => {
  const { config } = useApplicationContext();

  const { id, name } = useSelector(selectBuilderInfo);

  const widgetsMap = config.get<Record<string, string>>('Countryside.BuilderToReviewWidgetMap') || {};

  const widgetId = widgetsMap[id];

  if (!widgetId) {
    return null;
  }

  return <BuilderReviews url={`${REVIEWS_BASE_URL}?id=${widgetId}`} title={`Отзывы о компании «${name}»`} />;
};
